<template>
    <v-container fluid grid-list-lg style="max-width: 1100px">
        <v-layout row wrap justify-center align-center class="headline-layout">
            <v-flex xs12 md6 class="px-3" style="text-align:start;">
                <v-layout row wrap>
                    <v-flex xs12 class="white--text headline" style="line-height: 50px">
                        Businesses run smoother with Vorsi ERP Software
                    </v-flex>
                    <v-flex xs12 class="white--text homepage-subheadline">
                        The fastest, easiest to use, ERP business suite. <br>
                        Contact us today to schedule a free demo of our software. <br><br>
                        <b>CHECK OUT OUR SOFTWARE DEMO ON OUR WEBSITE OR YOUTUBE!</b>
                    </v-flex>
                    <v-flex xs12 style="margin-top: 25px">
                        <v-layout class="schedule-a-demo-layout">
                            <v-btn large color="primary" @click="changeLocation('/contact-us')" dusk="DemoButton2"
                                   style="height: 45px">
                                Contact Us
                            </v-btn>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md6 class="px-3">
                <iframe
                    src="https://www.youtube.com/embed/qJlG34uIKz4"
                    id="vorsi-information-video"
                    allow="fullscreen"
                ></iframe>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    methods: {
        detectOS: () => window.detectOS(),
        scrollToOverview() {
            let pageOffset = window.pageYOffset,
                buttonPos = window.pageYOffset + document.getElementById('overview').getBoundingClientRect().top,
                elementPos = (document.body.scrollHeight - buttonPos < window.innerHeight)
                    ? document.body.scrollHeight - window.innerHeight : buttonPos,
                diff = elementPos - pageOffset,
                start,
                easing = function (t) {
                    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
                };
            if (!diff) return;
            window.requestAnimationFrame(function step(timestamp) {
                if (!start) start = timestamp;
                let time = timestamp - start;
                window.scrollTo(0, pageOffset + diff * easing(Math.min(time / 1000, 1)));
                if (time < 1000) {
                    window.requestAnimationFrame(step);
                }
            });
        },
        changeLocation(route) {
            window.location = route;
        },
    },
};
</script>

<style scoped>

</style>
